import { Component, inject, Input, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { ConnectionMethods } from '@vendasta/platform-integrations';
import { CommonModule } from '@angular/common';
import { CardDataService } from '../../card-data.service';
import { IntegrationCard } from '../../model/Integration-connections-detail';

@Component({
  selector: 'platform-integration-disconnect-alert',
  imports: [TranslateModule, GalaxyAlertModule, CommonModule],
  templateUrl: './disconnect-alert.component.html',
  styleUrl: './disconnect-alert.component.scss',
})
export class DisconnectAlertComponent {
  @Input() disconnectedCards?: Signal<IntegrationCard[]>;
  protected readonly connectionMethods = ConnectionMethods;
  private readonly cardService = inject(CardDataService);
  reconnectConnection() {
    if (this.disconnectedCards) {
      const cards = this.disconnectedCards();
      this.cardService.handleConnection(cards);
    }
  }
}
